import { initializeApp } from "firebase/app";
import {
  deleteUser,
  EmailAuthProvider,
  getAuth,
  GoogleAuthProvider,
  reauthenticateWithCredential,
  reauthenticateWithPopup,
} from "firebase/auth";
import { getDatabase, ref, remove, update } from "firebase/database";
import { getStorage } from "firebase/storage";
import { toast } from "react-toastify";

const firebaseConfig = {
   apiKey: "AIzaSyBSBaq8nsw4Gx0zdXRes4basLXbeDw1uAs",
  authDomain: "sapid-21ca2.firebaseapp.com",
  databaseURL: "https://sapid-21ca2-default-rtdb.firebaseio.com",
  projectId: "sapid-21ca2",
  storageBucket: "sapid-21ca2.appspot.com",
  messagingSenderId: "791934022315",
  appId: "1:791934022315:web:18fa9ca7b3ec3949303dee",
  measurementId: "G-9XVEMNR285"

  // apiKey: "AIzaSyBLYrSL9htFTqRGHBgORcpiKSPn6Uelp28",
  // authDomain: "testingappproject-85ec5.firebaseapp.com",
  // databaseURL: "https://testingappproject-85ec5-default-rtdb.firebaseio.com",
  // projectId: "testingappproject-85ec5",
  // storageBucket: "testingappproject-85ec5.appspot.com",
  // messagingSenderId: "1042136114252",
  // appId: "1:1042136114252:web:ae287774d8503641c1c0e9",
  // measurementId: "G-4PXYRFLD0W",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);

console.log(auth);

const deleteSignedUser = async (password = null, afterdel,t) => {
  try {
    const user = auth.currentUser;

    if (!user) {
      console.log("No authenticated user.");
      return;
    }

    const providerId = user.providerData[0]?.providerId;

    // 🔐 Reauthenticate
    if (providerId === "password") {
      if (!password) {
        alert("Password is required.");
        return;
      }

      const credential = EmailAuthProvider.credential(
        user.email,
        password
      );

      await reauthenticateWithCredential(user, credential);
    } 
    else if (providerId === "google.com") {
      const googleProvider = new GoogleAuthProvider();
      await reauthenticateWithPopup(user, googleProvider);
    }

    // 🔥 Remove user data from database
    await remove(ref(db, "User/" + user.uid));

    // 🔥 Delete auth account
    await deleteUser(user);

    // 🔥 Clear localStorage safely
    localStorage.removeItem("provider");
    localStorage.removeItem("email");
    localStorage.removeItem("pass");

    if (afterdel) afterdel();

    console.log("User deleted successfully");

  } catch (error) {
    console.log("Delete Error:", error);

    if (error.code === "auth/wrong-password") {
      toast.error(t("Wrongpassword"));
    } else if (error.code === "auth/requires-recent-login") {
      toast.error("Please login again and try.");
    } else {
      toast.error("Account deletion failed.");
    }
  }
};

export { auth, provider, db, app, storage, deleteSignedUser };
